module.exports = __webpack_public_path__ + "static/img/4253@3x.62159d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/nav/4253@3x.png
// module id = 5hZW
// module chunks = 0